import { useParams } from 'react-router';

import { PayerCapabilityDetails } from 'pages/npiManagement/payerCapabilities/PayerCapabilityDetails';
import { PayerCapabilityList } from 'pages/npiManagement/payerCapabilities/PayerCapabilityList';

export const PayerCapabilityTab = () => {
    const { payerId } = useParams();
    return !payerId ? <PayerCapabilityList /> : <PayerCapabilityDetails />;
};
